import { Injectable } from "@angular/core";
import { Action, State, StateContext } from "@ngxs/store";
import { CustomState } from "../CustomState";
import { CuoteoAcciones } from "./cuoteo.acciones";
import { CuoteoDatosDTO, CuoteoResultadoDTO } from "@DTOS";
import { Nilable } from "@shared/utils";

export interface ICuoteoState {
    datosCuoteo: Nilable<CuoteoDatosDTO>;
    datasetName: string;
    datasetInfo: string;
    resultadosCuoteo: Nilable<CuoteoResultadoDTO>;
}

@State<ICuoteoState>({
    name: "cuoteo",
    defaults: {
        datosCuoteo: null,
        datasetName: "",
        datasetInfo: "",
        resultadosCuoteo: null
    }
})
@Injectable()
export class CuoteoState extends CustomState<ICuoteoState> {
    @Action(CuoteoAcciones.CargarDatos)
    public cargarDatosCuoteo(ctx: StateContext<ICuoteoState>, action: CuoteoAcciones.CargarDatos) {
        const nuevoState = this.obtenerNuevoState(ctx);

        nuevoState.datosCuoteo = action.datos;
        nuevoState.datasetName = action.datasetName;
        nuevoState.datasetInfo = action.datasetInfo;

        ctx.setState(nuevoState);
    }

    @Action(CuoteoAcciones.CargarResultados)
    public cargarResultadoCuoteo(ctx: StateContext<ICuoteoState>, action: CuoteoAcciones.CargarResultados) {
        const nuevoState = this.obtenerNuevoState(ctx);

        nuevoState.resultadosCuoteo = action.resultados;

        ctx.setState(nuevoState);
    }

    @Action(CuoteoAcciones.ReiniciarDatos)
    public reiniciarDatosCuoteo(ctx: StateContext<ICuoteoState>) {
        const nuevoState = this.obtenerNuevoState(ctx);

        nuevoState.datosCuoteo = null;
        nuevoState.datasetName = "";
        nuevoState.datasetInfo = "";
        nuevoState.resultadosCuoteo = null;

        ctx.setState(nuevoState);
    }
}
